// Version : 0.0.1
// Author : VISHNU
//Last ADD : add update code not working changes changes for alignment unwanted code remove response handle changes for alignement input '
// MODFIED DATA : 06-08-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';
import LoanIndexDisbursementActionTypes from './loan-index-disbursement.types';
import {
	fetchParticularLoanIndexDetails,
	deleteParticularLoanIndexDetails,
	fetchLoanScheduleList,
	updateLoanIndexFunder,
	updateLoanIndexMeettime,
	updateLoanIndexPOL,
	createLoanIndexDisbursement,
	createTransactionDisbursement,
	createTransactionAdditionalCharges,
	fetchFinanceAccountsList,
	fetchNextTransactionSerialNo,
	fetchProductAccountDetails,
	fetchVoucherCountBasedOnCompany,
	fetchInterBranchContra,
	fetchAllProductAdditionalAccount,
	fetchAllRangeProduct,
	createTopupLoanIndex,
	hdfcPayoutTransactionGet,
	fetchInstructionDetails,
} from './loan-index-disbursement.service';
import {
	fetchParticularLoanIndexDetailsSuccess,
	fetchParticularLoanIndexDetailsFailure,
	fetchParticularLoanIndexDetailsResponseChanged,
	deleteParticularLoanIndexDetailsSuccess,
	deleteParticularLoanIndexDetailsFailure,
	deleteParticularLoanIndexDetailsResponseChanged,
	fetchFinanceAccountsListSuccess,
	fetchFinanceAccountsListFailure,
	fetchFinanceAccountsListResponseChanged,
	fetchLoanScheduleListSuccess,
	fetchLoanScheduleListFailure,
	fetchLoanScheduleListResponseChanged,
	updateLoanIndexFunderSuccess,
	updateLoanIndexFunderFailure,
	updateLoanIndexFunderResponseChanged,
	updateLoanIndexMeettimeSuccess,
	updateLoanIndexMeettimeFailure,
	updateLoanIndexMeettimeResponseChanged,
	updateLoanIndexPOLSuccess,
	updateLoanIndexPOLFailure,
	updateLoanIndexPOLResponseChanged,
	createLoanIndexDisbursementSuccess,
	createLoanIndexDisbursementFailure,
	createLoanIndexDisbursementResponseChanged,
	createTransactionDisbursementSuccess,
	createTransactionDisbursementFailure,
	createTransactionDisbursementResponseChanged,
	createTransactionAdditionalChargesSuccess,
	createTransactionAdditionalChargesFailure,
	createTransactionAdditionalChargesResponseChanged,
	fetchNextTransactionSerialNoSuccess,
	fetchNextTransactionSerialNoFailure,
	fetchNextTransactionSerialNoResponseChanged,
	fetchProductAccountDetailsSuccess,
	fetchProductAccountDetailsFailure,
	fetchProductAccountDetailsResponseChanged,
	fetchVoucherCountBasedOnCompanySuccess,
	fetchVoucherCountBasedOnCompanyFailure,
	fetchVoucherCountBasedOnCompanyResponseChanged,
	fetchInterBranchContraSuccess,
	fetchInterBranchContraFailure,
	fetchInterBranchContraResponseChanged,
	fetchAllProductAdditionalAccountSuccess,
	fetchAllProductAdditionalAccountFailure,
	fetchAllProductAdditionalAccountResponseChanged,
	fetchAllRangeProductSuccess,
	fetchAllRangeProductFailure,
	fetchAllRangeProductResponseChanged,
	createTopupLoanIndexSuccess,
	createTopupLoanIndexFailure,
	createTopupLoanIndexResponseChanged,
	fetchInstumentListResponseChanged,
	fetchInstumentListFailure,
	fetchInstumentListSuccess,
	getInvestorDetailsResponseChanged,
	getInvestorDetailsFailure,
	getInvestorDetailsSuccess,
	hdfcPayoutTransactionFailure,
	hdfcPayoutTransactionSuccess,
	hdfcPayoutTransactionResponseChanged,
} from './loan-index-disbursement.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
/** *********************  START FETCH LOAN INDEX DETAILS  ******************** */
export function* particularLoanIndexDetails({ payload }: any) {
	try {
		const key = 'FetchParticularLoanIndexDetails';
		const { loanIndexID, databaseName } = payload;
		const jsonData = {
			loanIndexID: loanIndexID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchParticularLoanIndexDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchParticularLoanIndexDetailsFailure(responseData.data));
		} else {
			yield put(fetchParticularLoanIndexDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchParticularLoanIndexDetailsFailure(error));
	}
}

export function* resetParticularLoanIndexDetailsResponse() {
	yield put(fetchParticularLoanIndexDetailsResponseChanged());
}

export function* onFetchParticularLoanIndexDetails() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.FETCH_PARTICULAR_LOAN_INDEX_DETAILS_START,
		particularLoanIndexDetails,
	);
}

export function* onParticularLoanIndexDetailsResponseReset() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.FETCH_PARTICULAR_LOAN_INDEX_DETAILS_RESPONSE_RESET,
		resetParticularLoanIndexDetailsResponse,
	);
}
/** *********************  END FETCH LOAN INDEX DETAILS  ******************** */

/*********** DELETE PARTICULAR LOAN INDEX START ************************ */
export function* onDeleteParticularLoanIndexDetails({ payload }: any) {
	try {
		const key = 'DeleteParticularMemberInLoanIndexKey';
		const { loanIndexID, databaseName, ligmID } = payload;
		const jsonData = {
			LoanIndexID: loanIndexID,
			DatabaseName: databaseName,
			LoanIndexGroupMemberID: ligmID,
			FromDisbursement: '1',
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(deleteParticularLoanIndexDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteParticularLoanIndexDetailsFailure(responseData.data));
		} else {
			yield put(deleteParticularLoanIndexDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteParticularLoanIndexDetailsFailure(error));
	}
}

export function* resetDeleteParticularLoanIndexDetailsResponse() {
	yield put(deleteParticularLoanIndexDetailsResponseChanged());
}

export function* onDeleteParticularLoanDetails() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.DELETE_PARTICULAR_LOAN_INDEX_DETAILS_START,
		onDeleteParticularLoanIndexDetails,
	);
}

export function* onDeleteParticularLoanIndexDetailsResponseReset() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.DELETE_PARTICULAR_LOAN_INDEX_DETAILS_RESPONSE_RESET,
		resetDeleteParticularLoanIndexDetailsResponse,
	);
}
/*********** DELETE PARTICULAR LOAN INDEX START ************************ */

/*********** FETCH FINANCE ACCOUNT START ************************ */
export function* financeAccountsListDetails({ payload }: any) {
	try {
		const key = 'FinanceAccountsBasedonTypeKey';
		const {
			branchID,
			databaseName,
			infogCompanyID,
			transactionDate,
			transactionType,
			disbursementCashType,
		} = payload;
		const jsonData = {
			BranchID: branchID,
			DatabaseName: databaseName,
			DisbursementCashType: disbursementCashType,
			InfogID: infogCompanyID,
			TransactionDate: transactionDate,
			TransactionType: transactionType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchFinanceAccountsList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchFinanceAccountsListFailure(responseData.data));
		} else {
			yield put(fetchFinanceAccountsListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchFinanceAccountsListFailure(error));
	}
}

export function* resetFinanceAccountsListResponse() {
	yield put(fetchFinanceAccountsListResponseChanged());
}

export function* onFetchFinanceAccountsList() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.FETCH_FINANCE_ACCOUNTS_START,
		financeAccountsListDetails,
	);
}

export function* onFinanceAccountsListResponseReset() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.FETCH_FINANCE_ACCOUNTS_RESPONSE_RESET,
		resetFinanceAccountsListResponse,
	);
}
/*********** FETCH FINANCE ACCOUNT END ************************ */

/*********** FETCH LOAN SCHEDULE LIST START ************************ */
export function* loanScheduleListDetails({ payload }: any) {
	try {
		const key = 'getLoanInfoBasedOnMembersBothclosedKey';
		const { companyID, databaseName, loanIndexID, memberID, loanType } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			LoanIndexID: loanIndexID,
			MemberID: memberID,
			LoanType: loanType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchLoanScheduleList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchLoanScheduleListFailure(responseData.data));
		} else {
			yield put(fetchLoanScheduleListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchLoanScheduleListFailure(error));
	}
}

export function* resetLoanScheduleListResponse() {
	yield put(fetchLoanScheduleListResponseChanged());
}

export function* onFetchLoanScheduleList() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.FETCH_LOAN_SCHEDULE_LIST_START,
		loanScheduleListDetails,
	);
}

export function* onLoanScheduleListResponseReset() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.FETCH_LOAN_SCHEDULE_LIST_RESPONSE_RESET,
		resetLoanScheduleListResponse,
	);
}
/*********** FETCH LOAN SCHEDULE LIST END ************************ */

/*********** UPDATE LOANINDEX FUNDER START ************************ */
export function* updateLoanIndexFunderDetails({ payload }: any) {
	try {
		const key = 'updateLoanIndexInvestorKey';
		const {
			companyID,
			databaseName,
			funderID,
			loanIndexGroupMemberID,
			existsFunderName,
			funderName,
			userName,
			userID,
			userAccessBranchID,
			loanIndexID,
			branchAccountID,
			newFunderPrincipalAccountID,
			investedAmount,
			existFunderPrincipalAccountID,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			NewInvestorID: funderID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			ExistsFunderName: existsFunderName,
			FunderName: funderName,
			UserName: userName,
			CreatedBy: userID,
			UserAccessBranchID: userAccessBranchID,
			LoanIndexID: loanIndexID,
			BranchAccountID: branchAccountID,
			NewFunderPrincipalAccountID: newFunderPrincipalAccountID,
			InvestedAmount: investedAmount,
			ExistFunderPrincipalAccountID: existFunderPrincipalAccountID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateLoanIndexFunder, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateLoanIndexFunderFailure(responseData.data));
		} else {
			yield put(updateLoanIndexFunderSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateLoanIndexFunderFailure(error));
	}
}

export function* resetUpdateLoanIndexFunderResponse() {
	yield put(updateLoanIndexFunderResponseChanged());
}

export function* onUpdateLoanIndexFunder() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.UPDATE_LOANINDEX_FUNDER_START,
		updateLoanIndexFunderDetails,
	);
}

export function* onUpdateLoanIndexFunderResponseReset() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.UPDATE_LOANINDEX_FUNDER_RESPONSE_RESET,
		resetUpdateLoanIndexFunderResponse,
	);
}
/*********** UPDATE LOANINDEX FUNDER END ************************ */

/*********** UPDATE LOANINDEX MEETTIME START ************************ */
export function* updateLoanIndexMeettimeDetails({ payload }: any) {
	try {
		const key = 'updateLoanDisbursmentdateKey';
		const {
			loanIndexID,
			meetupTime,
			centerID,
			databaseName,
			previousMeetupTime,
			userName,
			userAccessBranchID,
			companyID,
			userID,
			loanStatus,
		} = payload;
		const jsonData = {
			LoanindexID: loanIndexID,
			MeetupTime: meetupTime,
			LocationID: centerID,
			DatabaseName: databaseName,
			MeetupTimebeforechange: previousMeetupTime,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
			CompanyID: companyID,
			CreatedBy: userID,
			LoanStatus: loanStatus,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateLoanIndexMeettime, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateLoanIndexMeettimeFailure(responseData.data));
		} else {
			yield put(updateLoanIndexMeettimeSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateLoanIndexMeettimeFailure(error));
	}
}

export function* resetUpdateLoanIndexMeettimeResponse() {
	yield put(updateLoanIndexMeettimeResponseChanged());
}

export function* onUpdateLoanIndexMeettime() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.UPDATE_LOANINDEX_MEETTIME_START,
		updateLoanIndexMeettimeDetails,
	);
}

export function* onUpdateLoanIndexMeettimeResponseReset() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.UPDATE_LOANINDEX_MEETTIME_RESPONSE_RESET,
		resetUpdateLoanIndexMeettimeResponse,
	);
}
/*********** UPDATE LOANINDEX MEETTIME END ************************ */

/*********** UPDATE LOANINDEX PUROSE LOAN START ************************ */
export function* updateLoanIndexPOLDetails({ payload }: any) {
	try {
		const key = 'updatePurposeLoanInvestorKey';
		const {
			companyID,
			databaseName,
			memberPurposeOfLoanID,
			loanIndexGroupMemberID,
			existsLoanName,
			loanName,
			userName,
			userID,
			userAccessBranchID,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			NewInvestorID: memberPurposeOfLoanID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			ExistsLoanName: existsLoanName,
			LoanName: loanName,
			UserName: userName,
			CreatedBy: userID,
			UserAccessBranchID: userAccessBranchID,
		};
		// eslint-disable-next-line no-debugger
		debugger;
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateLoanIndexPOL, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateLoanIndexPOLFailure(responseData.data));
		} else {
			yield put(updateLoanIndexPOLSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateLoanIndexPOLFailure(error));
	}
}

export function* resetUpdateLoanIndexPOLResponse() {
	yield put(updateLoanIndexPOLResponseChanged());
}

export function* onUpdateLoanIndexPOL() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.UPDATE_LOANINDEX_POL_START,
		updateLoanIndexPOLDetails,
	);
}

export function* onUpdateLoanIndexPOLResponseReset() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.UPDATE_LOANINDEX_POL_RESPONSE_RESET,
		resetUpdateLoanIndexPOLResponse,
	);
}
/*********** UPDATE LOANINDEX PUROSE LOAN END ************************ */

/*********** CREATE LOAN INDEX DISBURESEMENT START ************************ */
export function* createLoanIndexDisbursementDetails({ payload }: any) {
	try {
		const key = 'createOnGoingProductLoanIndexKey';
		const {
			companyID,
			databaseName,
			loanDisbursementDate,
			meetupTime,
			loanStatus,
			transactionType,
			loanIndexID,
			isTopUpLoan,
			userID,
		} = payload;
		const LoanDisbursementArray = JSON.stringify(payload.loanDisbursementArray).replace(
			/"/g,
			"'",
		);
		const ProductInvestors = JSON.stringify(payload.productInvestors).replace(/"/g, "'");
		const MemberThrift = JSON.stringify(
			payload.memberThriftOneArr && payload.memberThriftOneArr.length > 0
				? payload.memberThriftOneArr
				: [],
		).replace(/"/g, "'");
		const MemberThrift2 = JSON.stringify(
			payload.memberThriftTwoArr && payload.memberThriftTwoArr.length > 0
				? payload.memberThriftTwoArr
				: [],
		).replace(/"/g, "'");
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			Loandisbursementdate: loanDisbursementDate,
			MeetupTime: meetupTime,
			LoanIndexStatus: loanStatus,
			TransactionType: transactionType,
			LoanIndex: loanIndexID,
			IsTopUpLoan: isTopUpLoan,
			CreatedBy: userID,
			LoanDisbursementArray,
			MemberThrift,
			MemberThrift2,
			ProductInvestors,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(createLoanIndexDisbursement, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createLoanIndexDisbursementFailure(responseData.data));
		} else {
			yield put(createLoanIndexDisbursementSuccess(responseData.data));
		}
	} catch (error) {
		yield put(createLoanIndexDisbursementFailure(error));
	}
}

export function* resetCreateLoanIndexDisbursementResponse() {
	yield put(createLoanIndexDisbursementResponseChanged());
}

export function* onCreateLoanIndexDisbursement() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.CREATE_LOANINDEX_DISBURSEMENT_START,
		createLoanIndexDisbursementDetails,
	);
}

export function* onCreateLoanIndexDisbursementResponseReset() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.CREATE_LOANINDEX_DISBURSEMENT_RESPONSE_RESET,
		resetCreateLoanIndexDisbursementResponse,
	);
}
/*********** CREATE LOAN INDEX DISBURESEMENT END ************************ */

/*********** CREATE TRANSACTION DISBURSMENT START ************************ */
export function* createTransactionDisbursementDetails({ payload }: any) {
	try {
		const key = 'createDisbursementTranscationEntryKey';
		const TranscationArr = JSON.stringify(payload.transcationArr).replace(/"/g, "'");
		const {
			companyID,
			databaseName,
			infogCompanyID,
			account,
			entryDate,
			transactionType,
			totalAmount,
			userID,
			userName,
			staffCode,
			createdFor,
			branchName,
			userLevel,
			loanAdvanceAcc,
			provisionType,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			InfogCompanyID: infogCompanyID,
			AccountID: account,
			EntryDate: entryDate,
			TransactionType: transactionType,
			TotalAmount: totalAmount,
			CreatedBy: userID,
			UserName: userName,
			TranscationArr,
			StaffCode: staffCode,
			CreatedFor: createdFor,
			BranchName: branchName,
			IsLoanCollection: '0',
			UserLevel: userLevel,
			LoanAdvanceAcc: loanAdvanceAcc,
			ProvisionType: provisionType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(createTransactionDisbursement, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createTransactionDisbursementFailure(responseData.data));
		} else {
			yield put(createTransactionDisbursementSuccess(responseData.data));
		}
	} catch (error) {
		yield put(createTransactionDisbursementFailure(error));
	}
}

export function* resetCreateTransactionDisbursementResponse() {
	yield put(createTransactionDisbursementResponseChanged());
}

export function* onCreateTransactionDisbursement() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.CREATE_TRANSACTION_DISBURSEMENT_START,
		createTransactionDisbursementDetails,
	);
}

export function* onCreateTransactionDisbursementResponseReset() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.CREATE_TRANSACTION_DISBURSEMENT_RESPONSE_RESET,
		resetCreateTransactionDisbursementResponse,
	);
}
/*********** CREATE TRANSACTION DISBURSMENT END ************************ */

/*********** CREATE TRANSACTION ADDITIONAL CHARGES START ************************ */
export function* createTransactionAdditionalChargesDetails({ payload }: any) {
	try {
		const key = 'createAdditionalAccountTranscationEntryKey';
		const {
			companyID,
			databaseName,
			infogCompanyID,
			creditAccountID,
			disbursementDate,
			transaction_Type,
			totalAmount,
			userID,
			userName,
			staffCode,
			branchID,
			branchName,
		} = payload;
		const TranscationArr = JSON.stringify(payload.transcationArr).replace(/"/g, "'");
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			InfogCompanyID: infogCompanyID,
			AccountID: creditAccountID,
			EntryDate: disbursementDate,
			TransactionType: transaction_Type,
			TotalAmount: totalAmount,
			CreatedBy: userID,
			UserName: userName,
			TranscationArr,
			StaffCode: staffCode,
			CreatedFor: branchID,
			BranchName: branchName,
			IsLoanCollection: '0',
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(createTransactionAdditionalCharges, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createTransactionAdditionalChargesFailure(responseData.data));
		} else {
			yield put(createTransactionAdditionalChargesSuccess(responseData.data));
		}
	} catch (error) {
		yield put(createTransactionAdditionalChargesFailure(error));
	}
}

export function* resetCreateTransactionAdditionalChargesResponse() {
	yield put(createTransactionAdditionalChargesResponseChanged());
}

export function* onCreateTransactionAdditionalCharges() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.CREATE_TRANSACTION_ADDITIONAL_CHARGES_START,
		createTransactionAdditionalChargesDetails,
	);
}

export function* onCreateTransactionAdditionalChargesResponseReset() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.CREATE_TRANSACTION_ADDITIONAL_CHARGES_RESPONSE_RESET,
		resetCreateTransactionAdditionalChargesResponse,
	);
}
/*********** CREATE TRANSACTION ADDITIONAL CHARGES END ************************ */

/*********** FETCH NEXT TRANSACTION SERIAL NO START ************************ */
export function* nextTransactionSerialNoDetails({ payload }: any) {
	try {
		const key = 'nextTransactionSerialNumberKey';
		const { account, databaseName, infogCompanyID } = payload;
		const jsonData = {
			AccountID: account,
			DatabaseName: databaseName,
			CompanyID: infogCompanyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchNextTransactionSerialNo, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchNextTransactionSerialNoFailure(responseData.data));
		} else {
			yield put(fetchNextTransactionSerialNoSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchNextTransactionSerialNoFailure(error));
	}
}

export function* resetNextTransactionSerialNoResponse() {
	yield put(fetchNextTransactionSerialNoResponseChanged());
}

export function* onFetchNextTransactionSerialNo() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.FETCH_NEXT_TRANSACTION_SERIAL_NO_START,
		nextTransactionSerialNoDetails,
	);
}

export function* onNextTransactionSerialNoResponseReset() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.FETCH_NEXT_TRANSACTION_SERIAL_NO_RESPONSE_RESET,
		resetNextTransactionSerialNoResponse,
	);
}
/*********** FETCH NEXT TRANSACTION SERIAL NO END ************************ */

/*********** FETCH PRODUCT ACCOUNT DEATIL START ************************ */
export function* productAccountDetailsDetails({ payload }: any) {
	try {
		const key = 'productAccountDetailKey';
		const { databaseName, infogCompanyID, productID, companyID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			InfogID: infogCompanyID,
			ProductID: productID,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchProductAccountDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchProductAccountDetailsFailure(responseData.data));
		} else {
			yield put(fetchProductAccountDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchProductAccountDetailsFailure(error));
	}
}

export function* resetProductAccountDetailsResponse() {
	yield put(fetchProductAccountDetailsResponseChanged());
}

export function* onFetchProductAccountDetails() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.FETCH_PRODUCT_ACCOUNT_DETAILS_START,
		productAccountDetailsDetails,
	);
}

export function* onProductAccountDetailsResponseReset() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.FETCH_PRODUCT_ACCOUNT_DETAILS_RESPONSE_RESET,
		resetProductAccountDetailsResponse,
	);
}
/*********** FETCH PRODUCT ACCOUNT DEATIL END ************************ */

/*********** FETCH VOUCHER BASED ON COMPANY START ************************ */
export function* voucherCountBasedOnCompanyDetails({ payload }: any) {
	try {
		const key = 'GetCompanyVoucherCountBasedOnCompanyKey';
		const { transactionType, databaseName, infogCompanyID, branchID } = payload;
		const jsonData = {
			TransactionType: transactionType,
			DatabaseName: databaseName,
			CompanyID: infogCompanyID,
			CreatedFor: branchID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchVoucherCountBasedOnCompany, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchVoucherCountBasedOnCompanyFailure(responseData.data));
		} else {
			yield put(fetchVoucherCountBasedOnCompanySuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchVoucherCountBasedOnCompanyFailure(error));
	}
}

export function* resetVoucherCountBasedOnCompanyResponse() {
	yield put(fetchVoucherCountBasedOnCompanyResponseChanged());
}

export function* onFetchVoucherCountBasedOnCompany() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.FETCH_VOUCHER_COUNT_BASED_ON_COMPANY_START,
		voucherCountBasedOnCompanyDetails,
	);
}

export function* onVoucherCountBasedOnCompanyResponseReset() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.FETCH_VOUCHER_COUNT_BASED_ON_COMPANY_RESPONSE_RESET,
		resetVoucherCountBasedOnCompanyResponse,
	);
}
/*********** FETCH VOUCHER BASED ON COMPANY END ************************ */

/*********** FETCH INTER BRANCH CONTRA START ************************ */
export function* interBranchContraDetails({ payload }: any) {
	try {
		const key = 'getInterBranchContraAccountKey';
		const { databaseName, infogCompanyID, companyID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			InfogID: infogCompanyID,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchInterBranchContra, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchInterBranchContraFailure(responseData.data));
		} else {
			yield put(fetchInterBranchContraSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchInterBranchContraFailure(error));
	}
}

export function* resetInterBranchContraResponse() {
	yield put(fetchInterBranchContraResponseChanged());
}

export function* onFetchInterBranchContra() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.FETCH_INTER_BRANCH_CONTRA_START,
		interBranchContraDetails,
	);
}

export function* onInterBranchContraResponseReset() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.FETCH_INTER_BRANCH_CONTRA_RESPONSE_RESET,
		resetInterBranchContraResponse,
	);
}
/*********** FETCH INTER BRANCH CONTRA END ************************ */

/*********** FETCH ALL PRODUCT ADDITIONAL ACCOUNT START ************************ */
export function* allProductAdditionalAccountDetails({ payload }: any) {
	try {
		const key = 'getAllProductAdditionalAccountListKey';
		const { databaseName, infogCompanyID, companyID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			InfogID: infogCompanyID,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchAllProductAdditionalAccount, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllProductAdditionalAccountFailure(responseData.data));
		} else {
			yield put(fetchAllProductAdditionalAccountSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllProductAdditionalAccountFailure(error));
	}
}

export function* resetAllProductAdditionalAccountResponse() {
	yield put(fetchAllProductAdditionalAccountResponseChanged());
}

export function* onFetchAllProductAdditionalAccount() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.FETCH_ALL_PRODUCT_ADDITIONAL_ACCOUNT_START,
		allProductAdditionalAccountDetails,
	);
}

export function* onAllProductAdditionalAccountResponseReset() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.FETCH_ALL_PRODUCT_ADDITIONAL_ACCOUNT_RESPONSE_RESET,
		resetAllProductAdditionalAccountResponse,
	);
}
/*********** FETCH ALL PRODUCT ADDITIONAL ACCOUNT END ************************ */

/*********** FETCH ALL RANGE PRODUCT START ************************ */
export function* allRangeProduct({ payload }: any) {
	try {
		const key = 'getFilterRangeProductListKey';
		const { databaseName, productType, companyID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			ProductType: productType,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchAllRangeProduct, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllRangeProductFailure(responseData.data));
		} else {
			yield put(fetchAllRangeProductSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllRangeProductFailure(error));
	}
}

export function* resetAllRangeProductResponse() {
	yield put(fetchAllRangeProductResponseChanged());
}

export function* onFetchAllRangeProduct() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.FETCH_ALL_RANGE_PRODUCT_START,
		allRangeProduct,
	);
}

export function* onAllRangeProductResponseReset() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.FETCH_ALL_RANGE_PRODUCT_RESPONSE_RESET,
		resetAllRangeProductResponse,
	);
}
/*********** FETCH ALL RANGE PRODUCT END ************************ */

/*********** CREATE TOPUP LOAN INDEX START ************************ */
export function* CreateTopupLoanIndex({ payload }: any) {
	try {
		const LoanDisbursementArray = JSON.stringify(payload.loanDisbursementArray).replace(
			/"/g,
			"'",
		);
		const key = 'createTopupLoanIndexKey';
		const {
			loanIndexID,
			areaID,
			centerID,
			transactionType,
			databaseName,
			companyID,
			userID,
			disbursementDate,
			totalLoanAmount,
			meetupLocation,
			meetuplat,
			meetupLong,
			meetupTime,
			officerID,
			isPrecloseAndCreateTopupLoan,
		} = payload;
		const jsonData = {
			LoanIndexID: loanIndexID,
			AreaID: areaID,
			LocationID: centerID,
			LoanDisbursementArray,
			TransactionType: transactionType,
			DatabaseName: databaseName,
			CompanyID: companyID,
			CreatedBy: userID,
			Loandisbursementdate: disbursementDate,
			TotalLoanAmount: totalLoanAmount,
			MeetUpLocation: meetupLocation,
			MemberMeetupLat: meetuplat,
			MemberMeetupLong: meetupLong,
			MeetUpTime: meetupTime,
			GroupOfficerID: officerID,
			IsPrecloseAndCreateTopupLoan: isPrecloseAndCreateTopupLoan,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(createTopupLoanIndex, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createTopupLoanIndexFailure(responseData.data));
		} else {
			yield put(createTopupLoanIndexSuccess(responseData.data));
		}
	} catch (error) {
		yield put(createTopupLoanIndexFailure(error));
	}
}

export function* resetCreateTopupLoanIndexResponse() {
	yield put(createTopupLoanIndexResponseChanged());
}

export function* onCreateTopupLoanIndex() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.CREATE_TOPUP_LOAN_INDEX_START,
		CreateTopupLoanIndex,
	);
}

export function* onCreateTopupLoanIndexResponseReset() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.CREATE_TOPUP_LOAN_INDEX_RESPONSE_RESET,
		resetCreateTopupLoanIndexResponse,
	);
}
/*********** CREATE TOPUP LOAN INDEX END ************************ */

/** *********************  START INSTRUMENT LIST  ******************** */
export function* fetchInsturmentList({ payload }: any) {
	try {
		const key = 'GetAllInstrumentListKey';
		const { companyID, databaseName, infogCompanyID, userID } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			InfogCompanyID: infogCompanyID,
			CreatedBy: userID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchInstructionDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchInstumentListFailure(responseData.data));
		} else {
			yield put(fetchInstumentListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchInstumentListFailure(error));
	}
}

export function* resetFetchInsturmentListResponse() {
	yield put(fetchInstumentListResponseChanged());
}

export function* onFetchInsturmentListDetails() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.FETCH_INSTRUMENT_LIST_START,
		fetchInsturmentList,
	);
}

export function* onFetchInsturmentListResponseReset() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.FETCH_INSTRUMENT_LIST_RESPONSE_RESET,
		resetFetchInsturmentListResponse,
	);
}
/** *********************  END INSTRUMENT LIST ******************** */

/*********** GET INVESTOR DETAILS START ************************ */
export function* getInvestorDetailsSaga({ payload }: any) {
	try {
		const key = 'AllInvestmentMadeListKey';
		const { companyID, databaseName, infogCompanyID, userID, investorID } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			InfogCompanyID: infogCompanyID,
			CreatedBy: userID,
			InvestorID: investorID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getInvestorDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getInvestorDetailsFailure(responseData.data));
		} else {
			yield put(getInvestorDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getInvestorDetailsFailure(error));
	}
}

export function* resetGetInvestorDetailsResponse() {
	yield put(getInvestorDetailsResponseChanged());
}

export function* onGetInvestorDetails() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.GET_INVESTOR_DETAILS_START,
		getInvestorDetailsSaga,
	);
}

export function* onGetInvestorDetailsResponseReset() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.GET_INVESTOR_DETAILS_RESPONSE_RESET,
		resetGetInvestorDetailsResponse,
	);
}
/*********** GET INVESTOR DETAILS END ************************ */

/** *********************  START HDFC PAYOUT TRANSACTION  ******************** */
export function* hdfcPayoutTransaction({ payload }: any) {
	try {
		const key = 'HDFCPayoutTransactionKey';
		const {
			loanIndexID,
			loanindexGroupMemberID,
			companyID,
			companyName,
			memberID,
			transactionType,
			userID,
			databaseName,
		} = payload;
		const jsonData = {
			LoanIndexID: loanIndexID,
			loanindexGroupMemberID: loanindexGroupMemberID,
			CompanyID: companyID,
			CompanyName: companyName,
			MemberID: memberID,
			TransactionType: transactionType,
			UserID: userID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(hdfcPayoutTransactionGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(hdfcPayoutTransactionFailure(responseData.data));
		} else {
			yield put(hdfcPayoutTransactionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(hdfcPayoutTransactionFailure(error));
	}
}

export function* resetHdfcPayoutTransactionResponse() {
	yield put(hdfcPayoutTransactionResponseChanged());
}

export function* onHdfcPayoutTransactionDetails() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.HDFC_PAYOUT_TRANSACTION_START,
		hdfcPayoutTransaction,
	);
}

export function* onHdfcPayoutTransactionResponseReset() {
	yield takeLatest(
		LoanIndexDisbursementActionTypes.HDFC_PAYOUT_TRANSACTION_RESPONSE_RESET,
		resetHdfcPayoutTransactionResponse,
	);
}
/** *********************  END HDFC PAYOUT TRANSACTION ******************** */

export function* loanIndexDisbursementSaga() {
	yield all([
		call(onFetchParticularLoanIndexDetails),
		call(onParticularLoanIndexDetailsResponseReset),
		call(onDeleteParticularLoanDetails),
		call(onDeleteParticularLoanIndexDetailsResponseReset),
		call(onFetchFinanceAccountsList),
		call(onFinanceAccountsListResponseReset),
		call(onFetchLoanScheduleList),
		call(onLoanScheduleListResponseReset),
		call(onUpdateLoanIndexFunder),
		call(onUpdateLoanIndexFunderResponseReset),
		call(onUpdateLoanIndexMeettime),
		call(onUpdateLoanIndexMeettimeResponseReset),
		call(onUpdateLoanIndexPOL),
		call(onUpdateLoanIndexPOLResponseReset),
		call(onCreateLoanIndexDisbursement),
		call(onCreateLoanIndexDisbursementResponseReset),
		call(onCreateTransactionDisbursement),
		call(onCreateTransactionDisbursementResponseReset),
		call(onCreateTransactionAdditionalCharges),
		call(onCreateTransactionAdditionalChargesResponseReset),
		call(onFetchNextTransactionSerialNo),
		call(onNextTransactionSerialNoResponseReset),
		call(onFetchProductAccountDetails),
		call(onProductAccountDetailsResponseReset),
		call(onFetchVoucherCountBasedOnCompany),
		call(onVoucherCountBasedOnCompanyResponseReset),
		call(onFetchInterBranchContra),
		call(onInterBranchContraResponseReset),
		call(onFetchAllProductAdditionalAccount),
		call(onAllProductAdditionalAccountResponseReset),
		call(onFetchAllRangeProduct),
		call(onAllRangeProductResponseReset),
		call(onCreateTopupLoanIndex),
		call(onCreateTopupLoanIndexResponseReset),
		call(onFetchInsturmentListDetails),
		call(onFetchInsturmentListResponseReset),
		call(onGetInvestorDetails),
		call(onGetInvestorDetailsResponseReset),
		call(onHdfcPayoutTransactionDetails),
		call(onHdfcPayoutTransactionResponseReset),
	]);
}
